import { render, staticRenderFns } from "./TableOfCheckbox.vue?vue&type=template&id=35013c43"
import script from "./TableOfCheckbox.vue?vue&type=script&lang=js"
export * from "./TableOfCheckbox.vue?vue&type=script&lang=js"
import style0 from "./TableOfCheckbox.vue?vue&type=style&index=0&id=35013c43&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports